<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('funds')"
          :directory="[$t('funds'), $t('fund')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          <div class="dropdown d-inline-block btn-dropdown">
            <button
              type="button"
              class="btn btn-success dropdown-toggle ml-0 mr-2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ $t("actions") }}
            </button>
            <div class="dropdown-menu">
            
            
              <a
                class="dropdown-item d-flex align-items-center p-3"
                :href="urlGenerator(`crm/fund/type/list`)"
              >
                <app-icon
                  stroke-width="1"
                  :name="'settings'"
                  width="16"
                  height="16"
                  class="mr-3"
                />
                {{ $t("manage_lead_group") }}
              </a>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_fund") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-fund-modal
      v-if="isFundModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="fund-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    

    <app-fund-quick-view
      v-if="isQuickViewModalActive"
      dal-id="quickViewModal"
      :selected-url="selectedUrl"
      @openActivityModal="commonActivityModal"
      @viewAllDeal="openViewAllDeal"
      @viewAllFollower="openViewAllFollower"
      @editNote="editNote"
      @close-modal="closeQuickViewModal"
    />

  
 
   
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, inv, fundType, inrest, zal, tago, photo, desc, table, fulltext, restorer} from "@app/Mixins/Global/FilterMixins";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Fund",
  extends: CoreLibrary,
  mixins: [owner, inv, fundType,  inrest, zal, tago, photo, desc, table, fulltext, restorer, getCustomFileds, DeleteMixin],
  data() {
    return {
      urlGenerator,
      isFundModalActive: false,
      isContactModalActive: false,
      tableId: "fund-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      fundActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      fundId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      commonColumn: [
        
		{
          title: this.$t("fund-picture"),
          type: "custom-html",
          key: "profile_picture",
          modifier: (value, row) => {
            return value
              ? `<span class="img-list"><img src="${value.path}"/><div class="img-list-up"><img src="${value.path}"/></div></span>`
              : "-";
          },
        },
		{
          title: this.$t("title"),
          type: "link",
          key: "name",
          modifier: (value, row) => {
            return `crm/funds/${row.id}/edit`;
          },
        },
		 {
          title: this.$t("lead_group"),
          type: "custom-html",
          key: "fund_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
	    {
          title: this.$t("id"),
          type: "custom-html-new",
          key: "fund_type",
		  keye: "id",
          modifier: (value, row) => {
			  return value.symbol;
          },
        },
				
				
		
	
		   {
          title: this.$t("storage"),
          type: "custom-html",
          key: "inrest_type",
          modifier: (value, row) => {
            return value
              ? `<span>${
                  value.name
                }</span>`
              : "-";
          },
        },
        
		{
          title: this.$t("zal_type"),
          type: "custom-html",
          key: "zal_type",
          modifier: (value, row) => {
            return value
              ? `<span>${
                  value.name
                }</span>`
              : "-";
          },
        },
		  
		  {
          title: this.$t("restorer_type"),
          type: "custom-html",
          key: "restorer_type",
          modifier: (value, row) => {
            return value
              ? `<span>${
                  value.name
                }</span>`
              : "-";
          },
        },
		  
		    {
          title: this.$t("inv_type"),
          type: "custom-html",
          key: "inv_type",
          modifier: (value, row) => {
            return value
              ? `<span>${
                  value.name
                }</span>`
              : "-";
          },
        },
      
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("fund_table"),
        url: "crm/funds",
        showHeader: true,
        countView: true,
        columns: [],
        filters: [

       
          {
            title: this.$t("lead_group"),
            type: "drop-down-filter",
            key: "fund_type",
            keyt: "fund",
            option: [],
          },
			{
            title: this.$t("inrest_type"),
            type: "checkbox",
            key: "inrest_is",
            option: [],
          },
			{
            title: this.$t("zal_type"),
            type: "checkbox",
            key: "zal_is",
            option: [],
          },
			{
            title: this.$t("tago_type"),
            type: "radio",
            key: "tago_is",
            option: [],
          },
			{
            title: this.$t("photo_type"),
            type: "radio",
            key: "photo_is",
            option: [],
          },
			{
            title: this.$t("desc_type"),
            type: "radio",
            key: "desc_is",
            option: [],
          },
			{
            title: this.$t("table_type"),
            type: "radio",
            key: "table_is",
            option: [],
          },
			{
            title: this.$t("fulltext_type"),
            type: "radio",
            key: "fulltext_is",
            option: [],
          },
			{
            title: this.$t("inv_type"),
            type: "radio",
            key: "inv_is",
            option: [],
          },
			{
            title: this.$t("restorer_type"),
            type: "checkbox",
            key: "restorer_is",
            option: [],
          },
          {
            title: this.$t("with_manne"),
            type: "radio",
            key: "with_manne",
            option: [
            {
                id: 1,
                name: this.$t('filtr_with_manne'),
              },
            ],
            listValueField: "name",
          },
          {
            title: this.$t("add_created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
          {
            title: this.$t("buy_created_date"),
            type: "range-picker",
            key: "date_buy",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
		
         
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          /*{
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-fund-quick-view",
            modalId: "quickViewModal",
            url: "",
          },*/
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-fund-modal",
            modalId: "fund-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "fund-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
	  
	getFundValue() {
      this.axiosGet("crm/fund-value").then((response) => {
        this.options.filters.push({
          title: this.$t("fund_value"),
          type: "range-filter",
          key: "fund-value",
          minTitle: this.$t("minimum_value"),
          maxTitle: this.$t("maximum_value"),
          maxRange: response.data.max_fund_value,
          minRange:
            response.data.min_fund_value < response.data.max_fund_value
              ? response.data.min_fund_value
              : 0,
        });
      });
    },
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/funds/${rowData.id}`;
        this.isFundModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/funds/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("quick_view")) {
        this.selectedUrl = `crm/fund/navigation-change/${rowData.id + 1}?parm=previous`;
        this.isQuickViewModalActive = true;
      }
    },
    openModal() {
      this.isFundModalActive = true;
    },


    closeModal() {
      this.isFundModalActive = false;
      this.selectedUrl = "";
      $("#fund-modal").modal("hide");
    },
    closeQuickViewModal() {
      this.isQuickViewModalActive = false;
      this.selectedUrl = "";
      $("#quickViewModal").modal("hide");
    },
  
 
    closeViewAllModal() {
      this.viewAllDeal = false;
      $("#details-view-modal").modal("hide");
    },

 
   

  },
  computed: {

  },
  mounted() {
    this.getCustomFiled("fund");
	  setTimeout(() => {
      // this.$store.dispatch("getOwner"),
      this.getFundValue();
    }, 1000);
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
